import { RiDeleteBinLine } from "react-icons/ri";
import React, { useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import baseUrl from "../../../api/universalApi";

const CampaignHead = ({ influencerData, campaignData, creators }) => {
  // console.log("CampaignHead", campaignData)
  const [showPopUp, setshowPopUp] = useState(false);

  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    }).format(date);
  };

  const handleEditCampaign = () => {
    console.log("Campaign Data:", campaignData);
    try {
      const response = fetch(`${baseUrl}/api/campaigns/${campaignData._id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(campaignData),
      });
      if (response.ok) {
        console.log("Campaign edited successfully");
        // Optionally, you can redirect or update the state to reflect the changes
      } else {
        console.error("Failed to edit campaign");
      }
    } catch (error) {
      console.error("Error editing campaign:", error);
    }
  };

  const EditCampaign = () => {
    setshowPopUp(true);
  };

  const DeleteCampaign = () => {
    // Logic for deleting the campaign
    console.log("Delete Campaign");
  };

  return (
    <>
      {showPopUp && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-xl font-semibold mb-4">Edit Campaign</h2>
            {/* Add your form for editing campaign here */}
            <form className="space-y-4" onSubmit={()=>handleEditCampaign()}>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-2">
                  Campaign Name
                </label>
                <input
                  type="text"
                  value={campaignData.campaignName}
                  onChange={(e) => (campaignData.campaignName = e.target.value)}
                  className="w-full border border-gray-300 p-2 rounded"
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-2">
                  Campaign Description
                </label>
                <textarea
                  value={campaignData.campaignDescription}
                  onChange={(e) =>
                    (campaignData.campaignDescription = e.target.value)
                  }
                  className="w-full border border-gray-300 p-2 rounded"
                ></textarea>
              </div>
              {/* Add more fields as necessary */}
              <button type="submit" className="px-3 py-1 rounded-full border bg-green-300">Submit</button>
            </form>

            <button
              className="bg-blue-600 text-white px-3 py-1 rounded-full"
              onClick={() => setshowPopUp(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <div className="flex items-center flex-wrap justify-between mb-4 p-6 bg-white rounded-2xl  border-2 border-gray-200 ">
        <div className="flex items-center gap-6">
          <img
            src={
              campaignData?.campaignImage || "https://via.placeholder.com/150"
            }
            alt="Campaign"
            className="w-40 h-32 object-cover rounded-2xl border"
          />
          <div>
            <h2 className="text-2xl font-semibold mb-0">
              {campaignData?.campaignName}
            </h2>
            <p className="text-gray-600 mt-2 mb-0">
              {campaignData?.campaignDescription}
            </p>
            <p className="text-gray-600 mt-2 mb-0">
              Campaign Platform - {campaignData?.platform}
            </p>
            <p className="text-gray-800 mt-2">
              {formatDate(campaignData?.startDate)} -{" "}
              {formatDate(campaignData?.endDate)}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <button
            className="border border-gray-400 text-black p-2 rounded-lg hover:bg-gray-100"
            onClick={EditCampaign}
          >
            <FaRegEdit />
          </button>
          <button
            className="bg-red-600 text-white p-2 rounded-lg"
            onClick={DeleteCampaign}
          >
            <RiDeleteBinLine />
          </button>
        </div>
      </div>
    </>
  );
};

export default CampaignHead;
